// extracted by mini-css-extract-plugin
module.exports = {"form":"FormComponent_form__W-EAE"};